import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "file-upload" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", { disabled: "" }, "正在上传", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", null, "点击上传", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", null, "点击上传", -1)
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 1,
  class: "file-icon"
}
const _hoisted_7 = {
  key: 2,
  class: "file-icon"
}
const _hoisted_8 = { class: "filename" }
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingOutlined = _resolveComponent("LoadingOutlined")!
  const _component_FileOutlined = _resolveComponent("FileOutlined")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _mergeProps({
      class: ["upload-area", { 'is-dragover': _ctx.drag && _ctx.isDragOver }]
    }, _toHandlers(_ctx.events, true)), [
      (_ctx.isUploading)
        ? _renderSlot(_ctx.$slots, "loading", { key: 0 }, () => [
            _hoisted_2
          ])
        : (_ctx.lastFileData && _ctx.lastFileData.loaded)
          ? _renderSlot(_ctx.$slots, "uploaded", {
              key: 1,
              uploadedData: _ctx.lastFileData.data
            }, () => [
              _hoisted_3
            ])
          : _renderSlot(_ctx.$slots, "default", { key: 2 }, () => [
              _hoisted_4
            ])
    ], 16),
    _createElementVNode("input", {
      ref: "fileInput",
      type: "file",
      style: { display: 'none' },
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args)))
    }, null, 544),
    (_ctx.showUploadList)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          class: _normalizeClass(`upload-list upload-list-${_ctx.listType}`)
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filesList, (file) => {
            return (_openBlock(), _createElementBlock("li", {
              key: file.uid,
              class: _normalizeClass(`uploaded-file upload-${file.status}`)
            }, [
              (file.url && _ctx.listType === 'picture')
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "upload-list-thumbnail",
                    src: file.url,
                    alt: file.name
                  }, null, 8, _hoisted_5))
                : _createCommentVNode("", true),
              (file.status === 'loading')
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    _createVNode(_component_LoadingOutlined)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _createVNode(_component_FileOutlined)
                  ])),
              _createElementVNode("span", _hoisted_8, _toDisplayString(file.name), 1),
              _createElementVNode("span", {
                class: "delete-icon",
                onClick: ($event: any) => (_ctx.removeFile(file.uid))
              }, [
                _createVNode(_component_DeleteOutlined)
              ], 8, _hoisted_9)
            ], 2))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ]))
}